var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0016 6.2793H10.0016C9.72542 6.2793 9.50156 6.50315 9.50156 6.7793V8.87386C10.3777 8.81892 11.265 8.7793 12.0016 8.7793C12.7381 8.7793 13.6254 8.81892 14.5016 8.87386V6.7793C14.5016 6.50315 14.2777 6.2793 14.0016 6.2793ZM8.00156 6.7793V8.98161C7.79074 8.99846 7.58716 9.01538 7.39373 9.03194C6.37388 9.11924 5.60156 9.9771 5.60156 11.0007V13.9793C5.60156 15.0839 6.49699 15.9793 7.60156 15.9793L7.48257 16.9312C7.33336 18.1249 8.26413 19.1793 9.46713 19.1793H14.536C15.739 19.1793 16.6698 18.1249 16.5206 16.9312L16.4016 15.9793C17.5061 15.9793 18.4016 15.0839 18.4016 13.9793V11.0007C18.4016 9.9771 17.6292 9.11924 16.6094 9.03194C16.416 9.01538 16.2124 8.99846 16.0016 8.98161V6.7793C16.0016 5.67473 15.1061 4.7793 14.0016 4.7793H10.0016C8.89699 4.7793 8.00156 5.67473 8.00156 6.7793ZM9.27099 14.7173C9.30226 14.4671 9.51496 14.2793 9.76713 14.2793H14.236C14.4882 14.2793 14.7009 14.4671 14.7321 14.7173L15.0321 17.1173C15.0694 17.4157 14.8368 17.6793 14.536 17.6793H9.46713C9.16638 17.6793 8.93368 17.4157 8.97099 17.1173L9.27099 14.7173Z",
    fill: "#626B7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter);
export default __webpack_public_path__ + "static/media/icon-printer.9a1d9fcd413d270876b652b17bf8c8d6.svg";
export { ForwardRef as ReactComponent };